/**
 * Dependency injection
 */
import * as React from 'react';
export class Inject extends React.PureComponent {
    // tslint:disable-next-line:no-any
    render() {
        return null;
    }
}
Inject.isService = true;
